import gql from 'graphql-tag';

export default gql`
  query IsGrowthBookFeatureOn(
    $project: GrowthBookProject!
    $feature: String!
    $attributes: JSONObject!
    $anonymousId: String
    $sourceWriteKey: String
  ) {
    isGrowthBookFeatureOn(
      project: $project
      feature: $feature
      attributes: $attributes
      anonymousId: $anonymousId
      sourceWriteKey: $sourceWriteKey
    )
  }
`;
